const common = {
  close: "Закрыть",
  cancel: "Отмена",
  confirm: "Подтвердить",
  save: "Сохранить",
  delete: "Удалить",
  loading: "Загрузка...",
  error: "Ошибка",
  success: "Успешно",
  search: "Поиск...",
  noResults: "Результаты не найдены",
  retry: "Повторить",
  back: "Назад",
} as const;
export default common;
